import { useCallback } from 'react';

import { FetchErrorName } from '../../api/errors/types';
import { useGameConfig } from '../../config/GameConfigProvider';
import {
  fetchBonusCampaignsAction,
  fetchBonusCampaignsJwtAction,
} from '../../store/apiActions/fetchBonusPromotionAction';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';

export const useFreeChipsFetcher = (): (() => void) => {
  const dispatch = useCoreDispatch();

  const jwt = useConfigSlice.playerConfig()?.jwtToken;
  const tableId = useConfigSlice.tableConfig()?.operatorGameId;
  const baseUrl = useConfigSlice.env()?.bonusPromotionsService;
  const { isChipless } = useGameConfig().config;
  const userId = useConfigSlice.userId();
  const jsessionId = useConfigSlice.JSESSIONID();
  const gsAddress = useConfigSlice.baseUrl();

  return useCallback(() => {
    if (isChipless || !baseUrl || !jwt || !tableId) {
      return;
    }

    dispatch(fetchBonusCampaignsAction({ env: baseUrl, jwt, tableId }))
      .unwrap()
      .catch((error: Error) => {
        if (error.name === FetchErrorName.UnauthorizedError && !!jsessionId && !!gsAddress && !!userId) {
          const fetchPromosJwtParams = { envGs: gsAddress, jsessionId, userId };

          dispatch(fetchBonusCampaignsJwtAction(fetchPromosJwtParams))
            .unwrap()
            .then((newJwt: string) => {
              dispatch(fetchBonusCampaignsAction({ env: baseUrl, jwt: newJwt, tableId }));
            });
        }
      });
  }, [baseUrl, dispatch, isChipless, jwt, tableId]);
};
